<template src="./AdminIdi.html"></template>

<script>
export default {
  name: 'admin-idi'
}
</script>

<style lang="scss" scoped src="./AdminIdi.scss">
</style>